<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-content"
      >
        <el-breadcrumb-item to="/sys/role">角色管理</el-breadcrumb-item>
        <el-breadcrumb-item>权限配置</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="role-container">
        <el-row :gutter="24">
          <el-col :span="6">
            <h6 class="box-title">组织架构</h6>
            <el-tree
              ref="tree"
              :data="groupList"
              highlight-current
              accordion
              show-checkbox
              node-key="groupId"
              :default-expanded-keys="treeExpandData"
              @check="checkChange"
              :props="defaultProps"
            >
            </el-tree>
          </el-col>
          <el-col :span="6">
            <h6 class="box-title">权限</h6>
            <el-select
              v-model="dataStatus"
              placeholder="请选择数据权限"
              style="width: 100%"
            >
              <el-option key="0" label="部门部分数据" value="0"></el-option>
              <el-option key="1" label="部门所有数据" value="1"></el-option>
              <el-option key="-1" label="仅自己" value="-1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" v-if="dataStatus == 0 && groupId">
            <h6 class="box-title">用户</h6>
            <el-transfer
              v-model="selectUserList"
              :titles="['未选择', '已选择']"
              :props="{
                key: 'userId',
                label: 'userName',
              }"
              :data="userList"
            >
            </el-transfer>
          </el-col>
        </el-row>
      </div>
      <div class="footer-btn">
        <el-button size="small" type="danger" @click="$router.back()"
          >取 消</el-button
        >
        <el-button size="small" type="success" @click="confirmConfig"
          >确 认</el-button
        >
      </div>
    </el-card>
  </div>
</template>

<script>
import { getDepartInfoListed } from "@/api/departMange";
import { pageFindUserList, pageFindDataUserInfo } from "@/api/roleMange";
export default {
  name: "RoleJurisdiction",
  data() {
    return {
      groupList: [],
      defaultProps: {
        children: "children",
        label: "groupName",
      },
      treeExpandData: [], // 默认展开的数组
      groupId: [],
      dataStatus: null,
      value: [],
      userList: [],
      selectUserList: [], // 已配置的人员列表
    };
  },
  watch: {
    dataStatus(newVal) {
      if (newVal == 0 && this.groupId) {
        this.getPageUserList();
      }
    },
  },
  created() {
    this.roleInfo = JSON.parse(this.$route.query.item);
    this.getDepartList();
  },

  methods: {
    async getDepartList() {
      let params = {
        companyId: this.roleInfo.companyId,
        userCode: Number(
          JSON.parse(window.sessionStorage.getItem("userInfo")).userId
        ),
        roleId: this.roleInfo.roleId,
      };
      const res = await getDepartInfoListed(params);
      if (res.code === "200") {
        this.groupList = res.data;
        if (res.data && res.data.length > 0) {
          this.recursionSearch(res.data);
        }
        this.treeExpandData.push(res.data[0].groupId);
        this.dataStatus = res.data[0].dataStatus.toString();
      } else {
        this.$message.error(res.msg);
      }
    },
    // 递归
    recursionSearch(data) {
      data.forEach((item) => {
        if (item.checkStatus) {
          this.groupId.push(item.groupId);
        } else {
          if (item.children && item.children.length > 0) {
            this.recursionSearch(item.children);
          }
        }
      });
      this.$refs.tree.setCheckedKeys(this.groupId);
    },
    //选择的部门
    checkChange(data, checked, node) {
      this.groupId = checked.checkedKeys;
      if (data.groupId && this.dataStatus == 0) {
        this.getPageUserList();
      }
      this.userList = [];
    },
    //查询用户列表
    async getPageUserList() {
      let params = {
        companyId: this.roleInfo.companyId,
        defaultPositionName: null,
        groupIds: this.groupId.toString(),
        pageNo: 1,
        pageSize: 500,
        roleId: this.roleInfo.roleId,
        userCode: Number(
          JSON.parse(window.sessionStorage.getItem("userInfo")).userId
        ),
        userName: null,
        userStatus: "-1",
      };
      const res = await pageFindUserList(params);
      if (res.code === "200") {
        res.data.list.pageQueryDataUserInfoDTOList.forEach((item) => {
          if (item.checkAuth) {
            this.selectUserList.push(item.userId);
          }
        });
        this.userList = res.data.list.pageQueryDataUserInfoDTOList;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 确认配置
    async confirmConfig() {
      let params = {
        companyId: this.roleInfo.companyId,
        roleId: this.roleInfo.roleId,
        defineAccessItemConfigurationDTOList: [
          {
            dataStatus: this.dataStatus,
            groupId: this.groupId.toString(),
            userCode: this.selectUserList.toString(),
          },
        ],
      };
      const res = await pageFindDataUserInfo(params);
      if (res.code === "200") {
        console.log(res);
        this.$message.success("配置成功");
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.role-container {
  padding: 20px;
  .box-title {
    line-height: 40px;
  }
}
.footer-btn {
  text-align: center;
  margin: 40px 0 0;
}
</style>